<template>
  <div class="pb-14 pt-12 md:mt-32 md:pb-24 lg:mt-52">
    <SectionHeadingCta
      :title="heading.title"
      :cta="heading.cta"
      :type="heading.type" />
    <Container class="mt-12 lg:mt-24">
      <div
        class="flex flex-wrap items-center justify-between rounded-xl border border-gray-200 border-opacity-10 bg-white bg-opacity-10 pb-10 pl-4 pr-8 pt-4 xs:pb-6 md:px-6 md:py-6 lg:py-10 lg:pl-10">
        <h3 class="w-full text-2xl text-white md:pr-4 lg:w-auto lg:pr-8 lg:text-3xl">We're a top rated employer</h3>
        <div class="mt-4 flex flex-wrap items-center lg:mt-0">
          <SvgGlassdoor class="mr-2.5 h-8" />
          <div class="mt-2.5 flex w-full items-center xs:mt-0 xs:w-auto">
            <div class="mr-4 text-base text-white lg:text-3xl">
              {{ number }}
            </div>
            <div class="relative">
              <div class="absolute left-0 top-0 z-10 flex space-x-2.5 overflow-hidden">
                <div
                  v-for="n in Math.ceil(number)"
                  :key="n"
                  class="flex-shrink-0">
                  <div
                    class="overflow-hidden"
                    :style="{ width: calculateWidth(n) }">
                    <SvgGlassdoorStar class="h-6 lg:h-8" />
                  </div>
                </div>
              </div>
              <div class="relative flex space-x-2.5">
                <SvgGlassdoorStar
                  v-for="n in 5"
                  :key="n"
                  class="h-6 grayscale lg:h-8" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'

  import type { CtaType } from '../../models/button'

  type glassdoorProps = {
    heading: {
      type: 'primary' | 'secondary'
      title: string
      cta: CtaType
    }
    subtitle: string
  }
  defineProps<glassdoorProps>()

  // TODO get the number from glassdor api
  const number = ref(4.4)

  const calculateWidth = (n: number) => {
    return Math.floor(number.value) === n - 1 ? `${(number.value - Math.floor(number.value)) * 100}%` : 'auto'
  }
</script>
